import type { TableQuery, GroupMailTableQuery } from "owa-mail-list-store";
import type { MailboxInfo } from "owa-client-types";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { isGroupSearch } from "./isGroupTableQuery";
import { getMailboxInfoForGroup } from "owa-mailbox-info/lib/getMailboxInfoForGroup";
import { isSovereignCloudInfraEnabled } from "owa-account-cloud";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

export default function getGroupMailboxInfoFromTableQuery(groupId: string, tableQuery: TableQuery): MailboxInfo {
    const mailboxInfo = isGroupSearch(tableQuery)
        ? getModuleContextMailboxInfo()
        : (tableQuery as GroupMailTableQuery).mailboxInfo;
    
    if (isGlobalFeatureEnabled("grp-centralizeRoutingHeaders")) {
        return getMailboxInfoForGroup(mailboxInfo, groupId);
    }
    else {
        const groupMailboxInfo: MailboxInfo = isSovereignCloudInfraEnabled()
            ? getMailboxInfoForGroup(mailboxInfo, groupId)
            : /* eslint-disable-next-line owa-custom-rules/require-mailbox-info-package -- (https://aka.ms/OWALintWiki)
               * To create a MailboxInfo object deep import and call the getMailboxInfoFor* function for the type of MailboxInfo you are creating.
               *	> MailboxInfo must be obtained from the owa-mailbox-info package. */
                {
                    type: "GroupMailbox",
                    userIdentity: mailboxInfo.userIdentity,
                    mailboxSmtpAddress: groupId,
                };
        
        return groupMailboxInfo;
    }
}
